// extracted by mini-css-extract-plugin
module.exports = {"i59q031":"i59q031"};